import { render, staticRenderFns } from "./CreateOpportunityModal.vue?vue&type=template&id=2175796c&scoped=true&"
import script from "./CreateOpportunityModal.vue?vue&type=script&lang=js&"
export * from "./CreateOpportunityModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateOpportunityModal.vue?vue&type=style&index=0&id=2175796c&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2175796c",
  null
  
)

export default component.exports